import { ReactNode } from 'react';
import { Element } from 'react-scroll';
import Footer from '../components/layout/Footer';
import Header from '../components/layout/Header';
const ScrollElement = Element as React.ComponentType<any>;

const MainLayout: React.FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <main className="h-screen overflow-y-auto scrollbar-none flex flex-col justify-between">
      <Header />
      {children}
      <ScrollElement id="footer" name="footer">
        <Footer />
      </ScrollElement>
    </main>
  );
};

export default MainLayout;
